"use strict";

$ = jQuery;

$(".jc-sidebar-toggler").on("click", function () {
  $(".jc-sidebar").toggleClass("show");
  $('body').toggleClass("jc-offcanvas-active");
});

$(".jc-sidebar-close").click(function (e) {
  $(".jc-sidebar").removeClass("show");
  $("body").removeClass("jc-offcanvas-active");
});

var $ofertas_conteudo = $('#offers-list'),
    $filterInputs = $('.jc-vertical-filter input'),
    $marcas = $('input[name="marcas[]"]'),
    $modelos = $('input[name="modelos[]"]'),
    $assinaturas = $('input[name="assinaturas[]"]'),
    $preco_min = $('input[name="preco_min"]'),
    $preco_max = $('input[name="preco_max"]'),
    $filtro_modelos = $('.filtro_modelos'),
    $limpar_filtro_btn = $('.jc-btn-limpar-filtro'),
    category = $ofertas_conteudo.data('category'),
    page = 1,
    filter_mobile_bar = $('.jc-filter-mobile-bar'),
    offers_loader = $('.jc-offers-loading'),
    loader = $('.jc-loader'),
    filterParams = [],
    modelsList = $('#models-list'),
    pages,
    no_result;

$('body>footer').remove();

update_pages();
update_no_result();

loader.addClass('d-none');

// Filtra ofertas
function filter_offers() {

  page = 1;

  var filters = {
    marcas: get_selected_options($marcas),
    modelos: get_selected_options($modelos),
    assinaturas: get_selected_options($assinaturas),
    preco_min: $preco_min.val().length > 0 ? convert_price($preco_min.val()) : null,
    preco_max: $preco_max.val().length > 0 ? convert_price($preco_max.val()) : null
  };

  var base_url = $ofertas_conteudo.data('base-url');
  update_url(filters, base_url);
  filters.action = 'jc_ajax_get_offers';

  filters.page = page;
  filters.category = category;

  setFilteredCheckedNumber();

  $ofertas_conteudo.empty();
  loader.removeClass('d-none');

  // Faz requisição e altera resultados exibidos
  $.ajax({
    url: ofertasAjaxHandler.url,
    type: 'POST',
    data: filters,
    success: function success(response) {
      console.log(response);
      $ofertas_conteudo.html(response.data.template);
      update_pages();
      update_no_result();
      gtm_count_offers_impression();
      loader.addClass('d-none');
    },
    error: function error(data) {}
  });
}

function get_offers_scroll() {

  var filters = {
    action: 'jc_ajax_get_offers',
    marcas: get_selected_options($marcas),
    modelos: get_selected_options($modelos),
    assinaturas: get_selected_options($assinaturas),
    preco_min: $preco_min.val().length > 0 ? convert_price($preco_min.val()) : null,
    preco_max: $preco_max.val().length > 0 ? convert_price($preco_max.val()) : null,
    category: category,
    page: page
  };

  // Faz requisição e altera resultados exibidos
  $.ajax({
    url: ofertasAjaxHandler.url,
    type: 'POST',
    data: filters,
    success: function success(response) {

      $ofertas_conteudo.append(response.data.template);

      dataLayer.push({
        'event': 'VirtualPageview',
        'virtualPageURL': window.location.pathname + window.location.search,
        'virtualPageTitle': 'Filtro - Ofertas 0km'
      });

      gtag('event', 'VirtualPageview', {
        'virtualPageURL': window.location.pathname + window.location.search,
        'virtualPageTitle': 'Filtro - Ofertas 0km'
      });

      dataLayerEstadao.push({
        'event': 'forcePvCheckout',
        'page': window.location.pathname + window.location.search
      });

      gtag('event', 'forcePvCheckout', {
        'page': window.location.pathname + window.location.search
      });

      update_no_result();

      gtm_count_offers_impression();
      loader.addClass('d-none');
    },
    error: function error(data) {}
  });
}

// Volta filtro para estado default
function reset_filters(update) {
  no_result = false;
  pages = false;
  $(document).scrollTop(0);
  page = 1;
  $(".jc-vertical-filter input:checkbox").prop("checked", false);
  $(".jc-vertical-filter input:text").val(null);
  $('#models').hide();

  // Atualiza url
  if (update) {
    update_url({}, $ofertas_conteudo.data('base-url'));
  }
}

getFilterParameters();
setFilteredElements();
setFilteredCheckedNumber();

var midiaOrigin = '';
midiaOrigin += typeof filterParams['utm_campaign'] !== "undefined" ? 'utm_campaign=' + filterParams['utm_campaign'][0] : '';
midiaOrigin += typeof filterParams['utm_medium'] !== "undefined" ? '&utm_medium=' + filterParams['utm_medium'][0] : '';
midiaOrigin += typeof filterParams['utm_source'] !== "undefined" ? '&utm_source=' + filterParams['utm_source'][0] : '';
midiaOrigin += typeof filterParams['utm_content'] !== "undefined" ? '&utm_content=' + filterParams['utm_content'][0] : '';
midiaOrigin += typeof filterParams['utm_term'] !== "undefined" ? '&utm_term=' + filterParams['utm_term'][0] : '';
midiaOrigin = midiaOrigin != '' ? '?' + (midiaOrigin.indexOf('&') != 0 ? midiaOrigin : midiaOrigin.substring(1)) : '';

$(document).on("click", ".jc-card a", function () {
  $(this).attr('href', $(this).attr("href") + midiaOrigin);
});

// Marcas
$marcas.click(function (e) {
  check_models();
  filter_offers();
});

// Modelos
$modelos.click(function (e) {
  filter_offers();
});

// Assinaturas
$assinaturas.click(function (e) {
  filter_offers();
});

// Preço mínimo - digitação
$preco_min.bind('keypress', function (e) {
  $(this).mask("#.##0", { reverse: true });
});

//Preço máximo - digitação
$preco_max.bind('keypress', function (e) {
  $(this).mask("#.##0", { reverse: true });
});

// Preco mínimo
$preco_min.change(function () {
  check_prices();
  filter_offers();
});

// Preco máximo
$preco_max.change(function () {
  check_prices();
  filter_offers();
});

$limpar_filtro_btn.click(function (e) {
  reset_filters(true);
  filter_offers();
});

check_models();

//Compartamento filtro mobile

$('.jc-filter-mobile-show').click(function (event) {
  $('.jc-filter-bar').toggleClass('show');
  $('body').toggleClass('modal-open');
});

//Desabilita comportamento menu principal do Jornal do Carro

$('.jc-nav-wrapper').css('position', 'static');
$('.jc-nav-top-bar').remove();

//Visibilidade da barra de filtro

var filterMobileBar = $('.jc-mobile-offer-filter-bar');
var footer = $('#offers-footer');

$(window).scroll(function () {
  var filterAreaLimit = footer.offset().top - (footer.height() + 150);
  if ($(this).scrollTop() > filterAreaLimit && !filterMobileBar.hasClass('hide')) {
    filterMobileBar.fadeOut();
    filterMobileBar.addClass('hide');
  } else if ($(this).scrollTop() < filterAreaLimit && filterMobileBar.hasClass('hide')) {
    filterMobileBar.fadeIn();
    filterMobileBar.removeClass('hide');
  }
});

//Comportamento dropdown no filtro

$('.jc-filter-content .dropdown-menu').on('click', function (event) {
  event.stopPropagation();
});

function getFilterParameters() {
  var pathname = decodeURIComponent(window.location.search.substring(1).replace(/\+/g, '%20'));

  if (pathname) {
    var variables = pathname.split('&');

    filterParams = [];

    for (var i = 0; i < variables.length; i++) {
      var elements = variables[i].split(/,|=/);
      var name = elements[0];
      var params = [];

      for (var j = 1; j < elements.length; j++) {
        params.push(elements[j]);
      }

      if (params[0]) {
        filterParams[name] = params;
      }
    }
  } else {
    filterParams = [];
  }
}

//Marca as opções de filtro de acordo com a url

function setFilteredElements() {

  $filterInputs.each(function () {
    setInputValue(this);
  });
}

function setInputValue(el) {
  var inputName = $(el).attr('name').replace("[]", "");
  var inputType = $(el).attr('type');
  var inputValue = $(el).val();
  var params = filterParams[inputName];

  //Checa se o valor existe nos parâmetros do filtro
  if (typeof params != 'undefined') {
    for (var i = 0; i < params.length; i++) {
      if (inputType == 'checkbox') {
        if (filterParams[inputName][i] === inputValue) {
          $(el).prop("checked", true);
          break;
        }
      } else {
        $(el).val(params);
      }
    }
  }
}

//Marca o número de opções do tipo checkbox marcadas

function setFilteredCheckedNumber() {

  var totalFilters = 0;

  $('.jc-filter-check-count').each(function (index, el) {
    var checkGroup = el.closest('.jc-filter-check-group');
    var checkInputs = $(checkGroup).find('input:checkbox:checked');
    var textInputs = $(checkGroup).find('input:text').filter(function () {
      return $(this).val();
    });
    var elementFilters = checkInputs.length + textInputs.length;

    // Inputs
    if (elementFilters > 0) {
      $(this).html(elementFilters).addClass('jc-filter-check-counted');
    } else {
      $(this).removeClass('jc-filter-check-counted');
    }

    totalFilters = totalFilters + elementFilters;
  });

  if (totalFilters > 0) {
    $('.jc-btn-offer-filter').addClass('jc-btn-offer-filtered');
    $('.jc-filter-total-count').html(totalFilters);
  } else {
    $('.jc-btn-offer-filter').removeClass('jc-btn-offer-filtered');
    $('.jc-filter-total-count').empty();
  }
}

function check_prices() {
  var preco_max = $preco_max.val();
  var preco_min = $preco_min.val();

  if (preco_min.length > 0 && preco_max.length > 0) {
    preco_max = convert_price(preco_max);
    preco_min = convert_price(preco_min);

    if (preco_min > preco_max) {
      $preco_max.val(preco_min);
      $preco_min.val(preco_max);
    }
  }
}

// Função que busca opções selecionadas dado o tipo de filtro
function get_selected_options(filter) {
  var selected_options = [];
  filter.each(function () {
    if ($(this).is(':checked')) {
      selected_options.push($(this).val());
    }
  });

  return selected_options.join(',');
}

// Atualiza URL dados os parâmetros do filtro
function update_url(filters, base_url) {
  $.each(filters, function (index, value) {
    if (value === "" || value === null || value === []) {
      delete filters[index];
    }
  });

  var url_query = $.param(filters, true);
  if (url_query) {
    base_url += '?' + url_query;
  }

  window.history.pushState("", "", base_url);
}

//Verifica os modelos de marca selecionada/removida no filtro
function check_models() {

  var selected_brands = get_selected_options($marcas);
  var selected_models = get_selected_options($modelos);
  var selected_brands_list = selected_brands.split(",");
  var selected_models_list = selected_models.split(",");
  var modelBrand = $('[data-modelbrand]');

  if (selected_brands) {
    $('#models').show();
  } else {
    modelsList.hide();
  }

  modelBrand.each(function (index, element) {

    var brandID = $(element).attr('data-modelbrand');
    var checkBox = $(element).find("input:checkbox");

    if (selected_brands_list.indexOf(brandID) >= 0) {
      $(element).show();
      modelsList.show();
    } else {
      $(element).hide();
      checkBox.prop("checked", false);
    }
  });
}

// Converte de "dinheiro" para inteiro
function convert_price(price_text) {
  return parseInt(price_text.replace(/\./g, ''));
}

function update_pages() {
  pages = parseInt($ofertas_conteudo.find('[data-pages]').data('pages'));
}

function update_no_result() {
  no_result = $('.jc-offers-no-result').length > 0;
}

$('.jc-sidebar-content')[0].addEventListener('scroll', load_more_content);
$('.jc-sidebar-content').on('touchmove', load_more_content);

function load_more_content() {

  if (loader[0].classList.contains('d-none') && pages > page && is_bottom_visible() && !no_result) {
    page++;
    loader.removeClass('d-none');
    get_offers_scroll();
  }
}

function is_bottom_visible() {
  var scroll = $('.jc-sidebar-content')[0].scrollTop;
  var maxScrollHeight = $('.jc-sidebar-content')[0].scrollHeight - $('.jc-sidebar-content')[0].clientHeight;
  var footerHeight = $('#offers-footer')[0].clientHeight;
  return maxScrollHeight - scroll - footerHeight <= 30;
};